import React from 'react';
import classNames from 'classnames';
import styles from './InfoBox.module.scss';

/**
 * Inline callout for contextual guidance/confirmation text next to a form
 * (e.g. "this action will do X"). `variant` picks the color treatment.
 * Pass `iconBg` to render the icon inside a solid color badge (e.g. a
 * standalone notice) instead of as a plain flat icon.
 */
export const InfoBox = ({
  icon,
  iconBg,
  variant = 'info',
  className,
  children,
}) => (
  <div
    className={classNames(
      styles.infoBox,
      styles[`infoBox_${variant}`],
      className
    )}
  >
    {icon &&
      (iconBg ? (
        <span className={styles.iconBadge} style={{ backgroundColor: iconBg }}>
          {icon}
        </span>
      ) : (
        <span className={styles.icon}>{icon}</span>
      ))}
    <div className={styles.content}>{children}</div>
  </div>
);
